import { Button } from "@tokenterminal/core/ui/button/Button"
import { Icon, type IconProps } from "@tokenterminal/core/ui/icon/Icon"

export function PresetSelector({
  presets = [],
  selectedPreset,
  setSelectedPreset,
}: {
  presets: { slug: string; name: string; icon?: IconProps["as"] }[]
  selectedPreset: string | null
  setSelectedPreset: (preset: string) => void
}) {
  return (
    <div className="flex gap-0.5 items-center justify-start flex-wrap">
      {presets.map((preset) => (
        <Button
          key={preset.slug}
          variant={selectedPreset === preset.slug ? "muted" : "ghost"}
          onPress={() => {
            setSelectedPreset(preset.slug)
          }}
        >
          {preset.icon && <Icon as={preset.icon} />}
          {preset.name}
        </Button>
      ))}
    </div>
  )
}
